<template>
  <div class="content-container">
    <h1 class="title">Sell Art</h1>
    <div class="content">
      <p>In the history of modern astronomy, there is probably no one greater leap forward than the building and launch of the space telescope known as the Hubble. While NASA has had many ups and downs, the launch and continued operation of the Hubble space telescope probably ranks next to the moon landings and the development of the Space Shuttle as one of the greatest space exploration accomplishments of the last hundred years.</p>
      <ul>
        <li>An amazing piece of astronomy</li>
        <li>Trivia that few people know is that in truth</li>
        <li>Ten percent of the universe is visible</li>
        <li>The Hubble really was a huge leap forward</li>
      </ul>
      <p>That is for the very simple reason that the Hubble can operate outside of the atmosphere of Earth. Trying to make significant space exploration via telescopes from the terrestrial surface of planet Earth is very difficult.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "sell"
};
</script>

<style lang="scss" scoped>
.title {
  color: #111215;
  font-size: 34px;
  font-weight: bold;
  letter-spacing: -0.5px;
  line-height: 38px;
  margin: 0;
  text-transform: uppercase;
}

.content {
  opacity: 0.6;
  color: #111215;
  font-size: 16px;
  font-weight: 500;
  line-height: 26px;
}
</style>